import { coerceValueRef } from "../authContext";
import type {
  AuthDescriptor,
  HeaderEntryRef,
  HeaderEntryRefInput,
  ValueRefInput,
} from "../authDescriptor";

type BasicAuthDescriptor = Extract<AuthDescriptor, { type: "basic" }> & {
  withHeaders: (extraHeaders: HeaderEntryRefInput[]) => AuthDescriptor;
};

function coerceHeader(h: HeaderEntryRefInput): HeaderEntryRef {
  return { name: h.name, value: coerceValueRef(h.value), scheme: h.scheme };
}

/**
 * Standard HTTP Basic auth. Use `.withHeaders(...)` to attach extra static or
 * templated headers (parallel to `oauthAuth.withHeaders(...)`); each extra
 * header resolves independently — a missing ValueRef just skips that one.
 */
export function basicAuth(opts: {
  username: ValueRefInput;
  password: ValueRefInput;
}): BasicAuthDescriptor {
  const username = coerceValueRef(opts.username);
  const password = coerceValueRef(opts.password);
  return Object.assign(
    {
      type: "basic" as const,
      username,
      password,
    },
    {
      withHeaders: (extraHeaders: HeaderEntryRefInput[]): AuthDescriptor => ({
        type: "basic",
        username,
        password,
        extraHeaders: extraHeaders.map(coerceHeader),
      }),
    }
  );
}
